<script lang="ts" setup>
import Button from 'primevue/button';
import { RouterLink } from 'vue-router';
</script>

<template>
  <Button v-slot="slotProps" as-child>
    <RouterLink
      :class="slotProps.class"
      class="px-8 py-3 font-semibold!"
      to="/contact-us"
      active-class=""
      exact-active-class=""
    >
      Contact Us
    </RouterLink>
  </Button>
</template>
